import React from 'react'
import { Box, Typography } from '@mui/material'
import { INTERAX_COLORS } from '../../../../constants/colors'

interface ControlTowerStatTileProps {
  icon: React.ReactNode
  iconColor: string
  value: string
  label: string
  testId?: string
}

/** One of the big-number tiles under a card's header: an icon, the figure, and what it counts. */
export const ControlTowerStatTile: React.FC<ControlTowerStatTileProps> = ({
  icon,
  iconColor,
  value,
  label,
  testId
}) => (
  <Box
    data-testid={testId}
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: { xs: 1, sm: 1.25, md: 1.25 },
      px: { xs: 1.25, sm: 1.5, md: 1.5 },
      py: { xs: 1, sm: 1.25, md: 1.25 },
      borderRadius: '14px',
      backgroundColor: INTERAX_COLORS.white04,
      border: `1px solid ${INTERAX_COLORS.white10}`,
      minWidth: 0
    }}
  >
    <Box sx={{ display: 'flex', color: iconColor, flexShrink: 0 }}>{icon}</Box>
    <Box sx={{ minWidth: 0 }}>
      <Typography sx={{ color: INTERAX_COLORS.white, fontWeight: 700, fontSize: '16px', lineHeight: '20px' }}>
        {value}
      </Typography>
      <Typography sx={{ color: INTERAX_COLORS.white70, fontSize: '12px', lineHeight: '16px' }} noWrap>
        {label}
      </Typography>
    </Box>
  </Box>
)
